import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=a3b28f4e&"
import script from "./payment.vue?vue&type=script&lang=ts&"
export * from "./payment.vue?vue&type=script&lang=ts&"
import style0 from "./payment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports